var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.exportData()}}},[_c('CButton',{staticClass:"btn btn action-c-btn btn-success m-auto curve-border "},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }